/**
 * Converts `map` to an array.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the converted array.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_mapToArray.js
 ** module id = 90
 ** module chunks = 0
 **/